import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const BaseSubnav = styled.nav`
    position: sticky;
    top: 0;
    height: ${({ theme }) => theme.subnav.height};
    background-color: ${COLORS.mlbGrey7};
    color: ${COLORS.mlbWhite};
    border-bottom: 1px solid ${COLORS.mlbGrey6};
    z-index: 10000;
    display: grid;
    grid-template-areas:
        'branding search menureels';
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    padding: 0 4px 0 7px;
    align-items: center;
    ${media.mdmin`
        grid-template-areas: 'search branding menureels';
        grid-template-columns: 1fr 1fr 1fr;
    `}
`;

export const BaseBrandingWrapper = styled.div`
    grid-area: branding;
    justify-self: self-start;
    white-space: nowrap;
    align-self: center;
`;

export const BaseSearchButtonWrapper = styled.div`
    {
        grid-area: search;
        justify-self: flex-end;

        button {
            font-size: 15px;
        }

        span {
            display: none;
        }

        ${media.lgmin`
            span {
                display: inline-block
            }
        `}
    }
`;

export const BaseMenuWrapper = styled.div`
    grid-area: menu;
    justify-self: center;
    ${media.lgmin`
        display: flex;
        flex-direction: row;
        &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 18px;
            margin: 0 10px;
            align-self: center;
            background-color: ${COLORS.mlbGrey6};
        }
    `}
`;

export const BaseMenuReels = styled.div`
    display: grid;
    grid-area: menureels;
    grid-template-areas: 'menu reel';
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;

    ${media.smmin`
        display: flex;
        flex-direction: row;
        justify-self: flex-end;
    `}

    button {
        margin-left: 5px;
        grid-area: reel;
        justify-self: flex-end;
        justify-content: center;

        span {
            display: none;
        }
    }

    ${media.lgmin`
        button {
            margin-left: 0px;
            span {
                display: inline-block
            }
        }
    `}
`;


export default BaseSubnav;
